"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalNullableDefaultNull = void 0;
const typebox_1 = require("@sinclair/typebox");
const nullable_default_null_1 = require("./nullable-default-null");
const OptionalNullableDefaultNull = (schema) => typebox_1.Type.Optional((0, nullable_default_null_1.NullableDefaultNull)(schema));
exports.OptionalNullableDefaultNull = OptionalNullableDefaultNull;
//# sourceMappingURL=optional-nullable-default-null.js.map